<div class="container" style="max-width: 100%;">
  <H1>View Boxes</H1>


  <div class="row">

    <div class="col-2" style="padding-bottom: 20px;text-align: left;">

      <label> Status:</label>
      <div style="display: flex;">
        <select class="form-control" name="Status" type="text" [(ngModel)]="SearchValue.Status" required
          placeholder=" Status" (change)="Search()">
          <option value="Recieved">Recieved</option>
          <option value="In Prep">In Prep</option>
          <option value="Prepped">Prepped</option>
          <option value="Distributed">Distributed</option>
          <option value="Allocated">Allocated</option>
          <option value="Done">Done</option>
        </select>
      </div>
    </div>

    <div class="col-2" style="padding-bottom: 20px;text-align: left;">

      <label> Provider Name:</label>
      <div style="display: flex;">
        <select class="form-control" name="Provider" type="text" [(ngModel)]="SearchValue.Provider" required
          placeholder=" Provider" (change)="Search()">
          <option *ngFor="let Provider of Providers; let i =index" value={{Provider}}>{{Provider}}
          </option>
        </select>
      </div>
    </div>


    <div class="col-2" style="padding-bottom: 20px;text-align: left;">

      <label> Distributor Name:</label>
      <div style="display: flex;">
        <select class="form-control" name="Distributor" type="text" [(ngModel)]="SearchValue.Distributor" required
          placeholder=" Distributor" (change)="Search()">
          <option *ngFor="let Distributor of Distributors; let i =index" value={{Distributor}}>{{Distributor}}
          </option>
        </select>
      </div>
    </div>

    <div class="col-2" style="padding-bottom: 20px;text-align: left;">

      <label> Client Name:</label>
      <div style="display: flex;">
        <select disabled class="form-control" name="ClientName" type="text" [(ngModel)]="SearchValue.ClientName" required
          placeholder=" Client Name" (change)="Search()">
          <option *ngFor="let ClientName of ClientNames; let i =index" value={{ClientName}}>{{ClientName}}
          </option>
        </select>
      </div>
    </div>



    <div class="col-2" style="padding-bottom: 20px;text-align: left;" *ngIf="false">

      <label> Client Province:</label>
      <div style="display: flex;">
        <select class="form-control" name="ClientProvince" type="text" [(ngModel)]="SearchValue.ClientProvince" required
          placeholder=" Client Province" (change)="Search()">
          <option *ngFor="let ClientProvince of ClientProvinces; let i =index" value={{ClientProvince}}>
            {{ClientProvince}}
          </option>
        </select>
      </div>
    </div>

    <div class="col-2" style="text-align: left;">
      <label>Search Box Number:</label>
      <div class="input-group mb-3">
        <input class="form-control" ID="details" name="details" type="text" [(ngModel)]="SearchValue.Boxno"
          placeholder="Type in something to search" (ngModelChange)="Search()" />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary btnClear" type="button" id="button-addon2"
            (click)="ClearBoxNoSearch()">X</button>
        </div>
      </div>
      <div>
        <button class="btn btn-warning" type="button" id="button-addon2" (click)="ClearSearch()">Clear Search</button>
        <button class="btn btn-success" type="button" id="button-addon2" (click)="btnDownloadReportClickExcel()"
          style="margin-left: 5%;">Export</button>
      </div>
    </div>

  </div>
  <div class="row">



    <div class="col-3" style="padding-bottom: 20px;">

      <label> Distributed Date:</label>
      <div class="input-group" style="margin-bottom:1rem!important;align-items: end;">
        <label>Start Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.DistributorStartDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 2px);width:200px"
          max={{SearchValue.DistributorEndDate}} />
      </div>

      <div class="input-group" style="align-items: end;">
        <label>End Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.DistributorEndDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 9px);width:200px"
          min={{SearchValue.DistributorStartDate}} />
      </div>
    </div>

    <div class="col-3" style="padding-bottom: 20px;">

      <label> Recieved Date:</label>
      <div class="input-group" style="margin-bottom:1rem!important;align-items: end;">
        <label>Start Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.RecievedStartDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 2px);width:200px"
          max={{SearchValue.RecievedEndDate}} />
      </div>

      <div class="input-group" style="align-items: end;">
        <label>End Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.RecievedEndDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 9px);width:200px"
          min={{SearchValue.RecievedStartDate}} />
      </div>
    </div>

    <div class="col-3" style="padding-bottom: 20px;">

      <label> Connection Date:</label>
      <div class="input-group" style="margin-bottom:1rem!important;align-items: end;">
        <label>Start Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.ConnectionStartDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 2px);width:200px"
          max={{SearchValue.ConnectionEndDate}} />
      </div>

      <div class="input-group" style="align-items: end;">
        <label>End Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.ConnectionEndDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 9px);width:200px"
          min={{SearchValue.ConnectionStartDate}} />
      </div>
    </div>

    <div class="col-3" style="padding-bottom: 20px;">

      <label> Activation Date:</label>
      <div class="input-group" style="margin-bottom:1rem!important;align-items: end;">
        <label>Start Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.ActivationStartDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 2px);width:200px"
          max={{SearchValue.ActivationEndDate}} />
      </div>

      <div class="input-group" style="align-items: end;">
        <label>End Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.ActivationEndDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 9px);width:200px"
          min={{SearchValue.ActivationStartDate}} />
      </div>
    </div>


  </div>




  <table class="viewDataTable" ID="tblData">
    <thead>
      <tr>
        <th class="viewDataTableHeading">Box Number</th>
        <th class="viewDataTableHeading">Provider</th>

        <th class="viewDataTableHeading">DateReceived</th>
        <th class="viewDataTableHeading">Status</th>
        <th class="viewDataTableHeading">Branch</th>
        <th class="viewDataTableHeading">Distributor</th>
        <th class="viewDataTableHeading">Province</th>

        <th class="viewDataTableHeading">Serial Number</th>
        <th class="viewDataTableHeading">Date Distributed</th>

        <th class="viewDataTableHeading">Client Name</th>
        <th class="viewDataTableHeading">Client Cell Number</th>
        <th class="viewDataTableHeading">Client Province</th>

        <th class="viewDataTableHeading">Connection Date</th>
        <th class="viewDataTableHeading">Activation Date</th>
        <th class="viewDataTableHeading">Client Area</th>
        <th class="viewDataTableHeading">Batch Number</th>
      </tr>
    </thead>

    <tr *ngFor="let data of data | paginate: { itemsPerPage: ItemsPerPage, currentPage: p }">
      <td class="viewDataTableCell">{{data.Boxno}}</td>
      <td class="viewDataTableCell">{{data.Provider}}</td>

      <td class="viewDataTableCell">{{data.DateReceived}}</td>
      <td class="viewDataTableCell">{{data.Status}}</td>
      <td class="viewDataTableCell">{{data.Branch}}</td>
      <td class="viewDataTableCell">{{data.Distributor}}</td>
      <td class="viewDataTableCell">{{data.Province}}</td>

      <td class="viewDataTableCell">{{data.SerialNumber}}</td>
      <td class="viewDataTableCell">{{data.DateDistributed}}</td>

      <td class="viewDataTableCell">{{data.ClientName}}</td>
      <td class="viewDataTableCell">{{data.ClientCellNumber}}</td>
      <td class="viewDataTableCell">{{data.ClientProvince}}</td>

      <td class="viewDataTableCell">{{data.Connection}}</td>
      <td class="viewDataTableCell">{{data.Activation}}</td>
      <td class="viewDataTableCell">{{data.ClientArea}}</td>
      <td class="viewDataTableCell">{{data.BatchNumber}}</td>
    </tr>

    <tr *ngIf="data.length <= 0">
      <td class="viewDataTableCell" colspan="15">No records found, please refine your search and try again.</td>
    </tr>

  </table>

  <pagination-controls (pageChange)="p = $event"></pagination-controls>

  <button class="btn btn-info" type="button" id="btnLoadMore" (click)="LoadMoreFields()"
    *ngIf="data.length === iRowsLoaded">Load More</button>





</div>


<!--Error popup-->
<div style="float: right;margin-left:20px;">
  <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
  </button>
</div>
<ng-template #content let-modal ID="Errormessage">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{PopupTitle}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">

      <span aria-hidden="true">

      </span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="dateOfBirth">
          {{DisplayErrormessage}}
        </label>
      </div>


    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
      Done
    </button>


  </div>
</ng-template>